import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import TYPES from '../../../config/Types'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import { IStatement } from '../../../model/statement'
import { Meta } from '../../../model/meta'
import { IUser, UserMeta } from '../../../model/user'
import userStore from '../../user/user-store'

export default async function fetchCreator(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    statementUtils.statementService.getCreator(statement).then((creator: IUser) => {
        // console.log('setting num jybes for index: ' + i + ': ' + numJybes.value)
        if (creator) {
            if (!userStore.state.users.has(creator.id as number)) {
                console.log('setting user in map: %j', creator)
                creator.meta = new UserMeta()
                userStore.commitSetUser({ user: creator })
                userStore.dispatchSetMeta(creator)
            }
            const mapUser = userStore.state.users.get(creator.id as number)
            console.log('setting creatpr in statement: %j', mapUser)
            if (mapUser) {
                statementStore.commitSetCreator({ statement: statement, creator: mapUser })
            }
        }
    })

    return
}
